import { CalendarScreen } from "@/app/modules/Calendar";
import { ErrorPage } from "@/components";
import { TEMPLATE_CALENDAR } from "@/const";
import { useMainTabs } from "@/hooks";
import { useMemo } from "react";

export const Calendar = () => {
  const { mainTabs, isLoading } = useMainTabs();

  const calendarTab = useMemo(
    () => mainTabs?.find((t) => t.TemplateId === TEMPLATE_CALENDAR),
    [mainTabs],
  );

  if (!isLoading && !calendarTab) {
    return <ErrorPage code={404} />;
  }

  return <CalendarScreen />;
};
